export default "__VITE_ASSET__DXSX7woy__"